import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { motion } from 'framer-motion';

const ImpressumPage = () => (
  <div className="bg-[#F8F5F0] min-h-screen">
    <Navbar />
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-testid="impressum-page"
      >
        <span className="text-[11px] tracking-[0.22em] uppercase text-[#8B7355] font-outfit mb-3 block">
          Rechtliches
        </span>
        <h1 className="font-cormorant text-4xl md:text-5xl text-[#2A2A2A] font-medium mb-12">
          Impressum
        </h1>

        <div className="prose font-outfit text-[#2A2A2A]/80 leading-relaxed space-y-8">
          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 space-y-1">
              <p className="font-semibold text-[#2A2A2A]">Schulz & Gojowy GbR</p>
              <p>Gardinen-Atelier · Raumausstatter-Meister · Polsterei</p>
              <p className="mt-3">An der Schneise 57</p>
              <p>13503 Berlin-Heiligensee</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Geschäftsführung</h2>
            <div className="bg-white border border-[#EDE8E0] p-6">
              <p>Frank Gojowy</p>
              <p>Christiane Wagner (geb. Schulz)</p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Kontakt</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 space-y-2">
              <p>
                <span className="text-[#8B7355] font-medium">Telefon:</span>{' '}
                <a href="tel:+493043115080" className="hover:text-[#8B7355] transition-colors">030 / 4 31 15 80</a>
              </p>
              <p>
                <span className="text-[#8B7355] font-medium">Fax:</span> 030 / 4 31 54 07
              </p>
              <p>
                <span className="text-[#8B7355] font-medium">E-Mail:</span>{' '}
                <a href="mailto:gardinenatelier@ausheiligensee.de" className="hover:text-[#8B7355] transition-colors">
                  gardinenatelier@ausheiligensee.de
                </a>
              </p>
              <p>
                <span className="text-[#8B7355] font-medium">Website:</span>{' '}
                <a href="https://www.gardinenatelier-berlin.de" target="_blank" rel="noopener noreferrer" className="hover:text-[#8B7355] transition-colors">
                  www.gardinenatelier-berlin.de
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Berufsrechtliche Angaben</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 space-y-2">
              <p>
                <span className="text-[#8B7355] font-medium">Kammer:</span> Handwerkskammer Berlin
              </p>
              <p>
                <span className="text-[#8B7355] font-medium">Betriebsnummer:</span> 100969
              </p>
              <p>
                <span className="text-[#8B7355] font-medium">Innung:</span> Raumausstatter-Innung Berlin
              </p>
              <p>
                <span className="text-[#8B7355] font-medium">Meisterbrief:</span> Frank Gojowy, erworben 1994
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Umsatzsteuer</h2>
            <div className="bg-white border border-[#EDE8E0] p-6">
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
              </p>
              <p className="font-semibold text-[#2A2A2A] mt-1">DE135900603</p>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Haftungsausschluss</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 space-y-4 text-sm">
              <div>
                <h3 className="font-semibold text-[#2A2A2A] mb-2">Haftung für Inhalte</h3>
                <p className="text-[#2A2A2A]/65">
                  Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-[#2A2A2A] mb-2">Haftung für Links</h3>
                <p className="text-[#2A2A2A]/65">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-[#2A2A2A] mb-2">Urheberrecht</h3>
                <p className="text-[#2A2A2A]/65">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-cormorant text-2xl text-[#2A2A2A] font-semibold mb-4">Streitschlichtung</h2>
            <div className="bg-white border border-[#EDE8E0] p-6 text-sm text-[#2A2A2A]/65">
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#8B7355] hover:underline">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="mt-3">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#EDE8E0]">
          <a href="/" className="font-outfit text-sm text-[#8B7355] hover:text-[#6B5440] transition-colors flex items-center gap-2">
            ← Zurück zur Startseite
          </a>
        </div>
      </motion.div>
    </main>
    <Footer />
  </div>
);

export default ImpressumPage;
